import { logger } from "cayo.ui";
import { commonMessages } from "@cayo/shared/messages/common";
import { getConnectors } from "./api";
import { AUTHDataType } from "./types";

export function openAuthWindowAndGetCode(authUrl: string): Promise<AUTHDataType> {
  return new Promise((resolve, reject) => {
    const width = 600;
    const height = 700;
    const left = (window.innerWidth - width) / 2;
    const top = (window.innerHeight - height) / 2;

    const authWindow = window.open(
      authUrl,
      "authPopup",
      `width=${width},height=${height},top=${top},left=${left}`
    );

    const interval = setInterval(() => {
      try {
        const currentUrl = authWindow?.location?.href;

        if (currentUrl && currentUrl?.toLowerCase().startsWith("http")) {
          const url = new URL(currentUrl);
          const code = url?.searchParams?.get("code");
          const error = url.searchParams.get("error") as string;
          const error_description = url.searchParams.get("error_description") as string;

          if (code) {
            clearInterval(interval);
            authWindow.close();
            resolve({
              code,
              error,
              error_description,
            });
          }
        }
      } catch (err) {
        logger.log(err);
      }

      if (authWindow?.closed) {
        clearInterval(interval);
        reject();
      }
    }, 500);
  });
}

export function validateEmails(emails: string[]): { index: number; errorMessage: string } | null {
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}(\.[0-9]{1,3}){3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (!emails.length) {
    return null;
  }

  for (let i = 0; i < emails.length; i++) {
    if (!emailRegex.test(emails[i])) {
      return { index: i, errorMessage: "Invalid email" };
    }
  }

  return null;
}

export async function defineChannelName(
  objectType: string,
  name: string,
  setLoadingText: (param: string | undefined) => void,
  dispatchWizardState: (param: any) => void
) {
  setLoadingText(commonMessages.loading.defaultMessage);
  try {
    const res = await getConnectors();
    const data = await res?.json();

    const count = data?.value?.filter((c: any) => c?.objectType === objectType)?.length;

    dispatchWizardState({
      type: "update",
      payload: {
        form: "chanelInfo",
        data: {
          name: `${name} ${count >= 1 ? count + 1 : ""}`,
        },
      },
    });
  } catch (err) {
    logger.log(err);
  } finally {
    setLoadingText(undefined);
  }
}
